import { LOAN_SECTION_KEYS } from "../loan.constants";

export const BORROWER_GROUP = {
  title: "Borrower Reporting",
  key: LOAN_SECTION_KEYS.BORROWERREPORTING,
  isTitleGroup: false,
  isExpandable: true,
  style: { backgroundColor: "#FBFBFB" },
  referencedFieldPath: "loans.financialReporting.borrowerDocs",
  isReferenceOptions: true
};

export const GUARANTOR_GROUP = {
  title: "Guarantor Reporting",
  key: LOAN_SECTION_KEYS.GUARANTORREPORTING,
  isTitleGroup: false,
  isExpandable: true,
  style: { backgroundColor: "#FBFBFB" },
  referencedFieldPath: "loans.financialReporting.guarantor",
  isReferenceOptions: true
};

export const CASHMANAGEMENT_GROUP = {
  title: "Cash Management Reporting",
  key: LOAN_SECTION_KEYS.CASHMANAGEMENTREPORTING,
  isTitleGroup: true,
  isExpandable: true,
  style: { backgroundColor: "#FBFBFB" },
  referencedFieldPath: "loans.financialReporting.cashManagement",
  isReferenceOptions: true
};
